import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext"; // YENİ: useAuth'u import ettik
import ProtectedRoute from "./components/ProtectedRoute";
import { ThemeProvider } from "./context/ThemeContext";

import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import StaffLayout from "layouts/staff";
import VaultLayout from "layouts/vault";
import CustomerLayout from "layouts/customer";

import FastBooking from "views/FastBooking/FastBooking";
import LandingPage from "views/pages/landing/landingpage";

// --- YENİ EKLENEN KISIM: GuestRoute ---
// Sadece giriş YAPMAMIŞ kullanıcıların görebileceği rotalar için koruma kalkanı
const GuestRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Context'ten kullanıcı bilgisi gelene kadar ekranın titremesini (flash) önle
  if (loading) {
    return null;
  }

  // Kullanıcı zaten giriş yapmışsa direkt kendi paneline (dashboard) fırlat!
  if (user) {
    return <Navigate to={`/${user.role}/dashboard`} replace />;
  }

  // Giriş yapmamışsa (misafirse) gitmek istediği sayfayı (ör: Landing, Login) göster
  return children;
};

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          {/* --- HERKESE AÇIK (MİSAFİR) ROTALAR --- */}

          {/* ANA SAYFA VE AUTH: Artık GuestRoute ile korunuyor. Giriş yapılıysa direkt içeri atacak. */}
          <Route
            path="/"
            element={
              <GuestRoute>
                <LandingPage />
              </GuestRoute>
            }
          />
          <Route
            path="auth/*"
            element={
              <GuestRoute>
                <AuthLayout />
              </GuestRoute>
            }
          />

          {/* Hızlı randevu genelde dışarıya açık olduğu için böyle kalabilir */}
          <Route path="hizli-randevu" element={<FastBooking />} />

          {/* --- YETKİ GEREKTİREN ROTALAR --- */}

          <Route
            path="admin/*"
            element={
              <ProtectedRoute roles={["admin", "vault", "staff"]}>
                <AdminLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="staff/*"
            element={
              <ProtectedRoute roles={["staff", "admin"]}>
                <StaffLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="vault/*"
            element={
              <ProtectedRoute roles={["vault", "admin", "staff"]}>
                <VaultLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="customer/*"
            element={
              <ProtectedRoute roles={["customer"]}>
                <CustomerLayout />
              </ProtectedRoute>
            }
          />

          {/* Varsayılan Yönlendirme */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
